<template>
  <div class="title">
    <router-link :to="{name:'Home'}">首页</router-link>
    <router-link v-for="(item,index) in linkList" :to="item.link?{path:`${item.link}`,query:item.query}:''" :key="index">&emsp;<span class="Breadcrumb"><i class="el-icon-arrow-right "></i></span>&emsp;{{ item.name }}</router-link>
  </div>
</template>

<script>
export default {
  name: "breadcrumb",
  props: {
    linkList : Array
  },

}
</script>

<style lang='less' scoped>
  .title{
    width: 1200px;
    height: 60px;
    display: flex;
    align-items: center;
    margin-left: 4px;

    a {
      font-size: 14px;
      font-family: PingFangSC-Thin, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      transition: color 0.2s ease;
      display: inline-flex;
      align-items: center;

      &:hover {
        color: var(--primary, #FF5A1F);
      }

      /* 斜切分隔（skewX(-20deg)），隐藏原箭头图标 */
      .Breadcrumb {
        display: inline-block;
        width: 7px;
        height: 11px;
        background: var(--border-soft, #E8E4DE);
        transform: skewX(-20deg);

        i {
          display: none;
        }
      }
    }

    a:last-of-type{
      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 600;
      color: var(--text-main, #1A1D24);

      &:hover {
        color: var(--text-main, #1A1D24);
      }
    }
  }
</style>
